var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCopyBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75016 2.08333H3.3335V2.5V13.75H2.50016V2.5C2.50016 1.81345 3.06361 1.25 3.75016 1.25H13.3335V2.08333H3.75016ZM16.2502 17.9167H16.6668V17.5V5.83333V5.41667H16.2502H7.0835H6.66683V5.83333V17.5V17.9167H7.0835H16.2502ZM7.0835 4.58333H16.2502C16.9367 4.58333 17.5002 5.14678 17.5002 5.83333V17.5C17.5002 18.1865 16.9367 18.75 16.2502 18.75H7.0835C6.39695 18.75 5.8335 18.1865 5.8335 17.5V5.83333C5.8335 5.14678 6.39695 4.58333 7.0835 4.58333Z",
    fill: "#787E7D",
    stroke: "#787E7D",
    strokeWidth: 0.833333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopyBlack);
export default __webpack_public_path__ + "static/media/content_copy_black.d90cfd504385de23a8b072958c9aa6a5.svg";
export { ForwardRef as ReactComponent };